/* 32 North — Theme JS
   Cart drawer, mobile menu, variant selection
   ============================================================ */

(function () {
  'use strict';

  /* ── Mobile Menu ─────────────────────────────────────────── */
  const menuToggle = document.querySelector('.menu-toggle');
  const headerNav = document.querySelector('.header-nav');

  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = headerNav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ── Cart Drawer ─────────────────────────────────────────── */
  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
    return res.json();
  }

  // Update cart count badge
  async function updateCartCount() {
    try {
      const cart = await fetchCart();
      const badge = document.querySelector('.header-cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      }
    } catch (e) {
      console.warn('Cart update failed:', e);
    }
  }

  // ATC forms (single-variant)
  document.querySelectorAll('[data-atc-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const id = form.querySelector('[name="id"]').value;
      const btn = form.querySelector('button[type="submit"]');
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        await addToCart(id);
        await updateCartCount();
        btn.textContent = 'Added ✓';
        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }, 2000);
      } catch {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      }
    });
  });

  /* ── Product Gallery Thumbs ──────────────────────────────── */
  const thumbs = document.querySelectorAll('.product-gallery-thumb');
  const mainImage = document.querySelector('.product-gallery-main img');

  if (thumbs.length && mainImage) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.querySelector('img')?.src;
        if (src) {
          mainImage.src = src;
          thumbs.forEach((t) => t.classList.remove('active'));
          thumb.classList.add('active');
        }
      });
    });
    thumbs[0]?.classList.add('active');
  }

  /* ── Variant Swatches ────────────────────────────────────── */
  document.querySelectorAll('.variant-swatches').forEach((group) => {
    group.querySelectorAll('.variant-swatch').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        group.querySelectorAll('.variant-swatch').forEach((s) => s.classList.remove('active'));
        swatch.classList.add('active');
        // Update hidden variant input
        const variantId = swatch.dataset.variantId;
        const variantInput = document.querySelector('[name="id"]');
        if (variantId && variantInput) variantInput.value = variantId;
      });
    });
  });

  /* ── Marquee pause on focus ──────────────────────────────── */
  const marquee = document.querySelector('.marquee-track');
  if (marquee) {
    marquee.addEventListener('focusin', () => marquee.style.animationPlayState = 'paused');
    marquee.addEventListener('focusout', () => marquee.style.animationPlayState = 'running');
  }

  /* ── Init cart count on load ─────────────────────────────── */
  updateCartCount();

})();
